import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HeaderReset } from '@carvana/showroom-theme';
import { createPortal } from 'react-dom';

import { IsServerSideRendering } from '../utilities';

const ResetWrapper = styled.div`
  ${HeaderReset}
`;

class Portal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);

    if (IsServerSideRendering) {
      return;
    }

    this.portalElement = document.createElement('div');
  }

  componentDidMount() {
    if (IsServerSideRendering) {
      return;
    }

    document.body.appendChild(this.portalElement);
  }

  componentWillUnmount() {
    if (IsServerSideRendering) {
      return;
    }
    document.body.removeChild(this.portalElement);
  }

  render() {
    if (IsServerSideRendering) {
      return null;
    }
    const { children } = this.props;

    const Reset = (<ResetWrapper>{children}</ResetWrapper>);

    return createPortal(Reset, this.portalElement);
  }
}

export default Portal;
